class Configuration {

    readonly apiUrl: string;
   
    constructor() {
        this.apiUrl = "https://api.linkevents.lochall.com"; // should be replaced at runtime by env.sh when running in docker.
        if (!this.apiUrl.startsWith("http")) {
            this.apiUrl = import.meta.env.VITE_TOPCHEF_API_URL;
        }
    }

}

export const topchefConfiguration = new Configuration();
